/*
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-10 15:17:15
 * @LastEditors: 赵佳明
 * @LastEditTime: 2024-04-20 15:46:47
 */
import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // Internationalization
import '@/icons' // icon
import './permission' // permission control
import './utils/errorLog' // error log

import * as filters from './filters' // global filters
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
// import { mockXHR } from '../mock' // simulation data

// mock api in github pages site build
// if (process.env.NODE_ENV === 'production') { mockXHR() }

Vue.use(Element, {
  size: Cookies.get('size') || 'mini', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

const publicData = {
  maxNumAble: 500,

  // imgUrl: 'https://xcx.tzwyfw.com'//正式打开
  imgUrl: 'http://tzyezhu.bjycst.top/'
  // imgUrl: 'http://localhost:8080/'
}
if(location.origin.indexOf('xcx.tzwyfw')!=-1){
  // 正式
  publicData.imgUrl = 'https://xcx.tzwyfw.com'
}
Vue.prototype.$publicData = publicData
Vue.prototype.$adddom = function (src) {
  if (src == "" || src == undefined || src == null) {
    // console.log("src地址有问题");
    return "";
  }
  if (src.substr(0, 4).toLowerCase() === "http") {
    return src;
  }
  return this.$publicData.imgUrl + src;
}
Vue.prototype.$toPath = function (url,obj) {
  this.$router.push({
    path: url,
    query: obj
  });
}
// import * as ElIcons from "@element-plus/icons-vue";
// for (const iconName in ElIcons) {
// 	Vue.component(iconName, ElIcons[iconName]);
// }
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
